<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <form @submit.prevent="handleSubmit(submitForm)">
      <BaseLayoutSpaced relaxed>
        <BaseLayoutSpaced>
          <ValidationProvider
            name="name"
            vid="name"
            rules="required"
            v-slot="{ errors, failed }"
            slim
          >
            <BaseFormGroup class="w-full">
              <BaseFormLabel> Name * </BaseFormLabel>
              <BaseFormInput
                v-model.lazy="data.name"
                :disabled="submitting"
                :invalid="failed"
                placeholder="enter list name..."
              />
              <BaseFormInlineMessage v-if="failed" danger>
                {{ errors[0] }}
              </BaseFormInlineMessage>
            </BaseFormGroup>
          </ValidationProvider>
        </BaseLayoutSpaced>
        <div class="flex space-x-2 py-1 items-baseline">
          <BaseButton primary type="submit" :disabled="invalid || submitting">
            <span v-if="!submitting">Submit</span>
            <Loader v-else small inverse />
          </BaseButton>
          <BaseButton ghost type="button" @click="$emit('cancel')" :disabled="submitting">
            Cancel
          </BaseButton>
          <BaseFormInlineMessage v-if="message" danger>
            {{ message }}
          </BaseFormInlineMessage>
        </div>
      </BaseLayoutSpaced>
    </form>
  </ValidationObserver>
</template>

<script>
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  mixins: [veeValidateErrorsMixin],

  props: {
    defaultData: {
      type: Object,
      default: () => ({
        name: '',
      }),
    },
    submitAction: {
      type: Function,
      default: () => {
        throw new Error('missing submit-action');
      },
    },
  },

  data() {
    return {
      submitting: false,
      data: { ...this.defaultData },
      message: null,
    };
  },

  methods: {
    async submitForm() {
      const submitWithErrorHandling = this.handleFormErrors(this.submitAction);

      this.submitting = true;

      await submitWithErrorHandling(this.data);

      this.submitting = false;
    },

    handleFormErrors(fn) {
      return (...params) =>
        fn(...params)
          .then(() => {
            this.$refs.modal.doClose();
          })
          .catch(({ status, data } = {}) => {
            // do sth with the error!
            if (status && status === HTTP_UNPROCESSABLE_ENTITY) {
              this.observer = this.$refs.observer;
              this.addServerErrors(data.errors);
            }
          });
    },
  },
};
</script>
